import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(values, lang) {
    const response = await api.fetch(`/api/v2/airbnb/configuration/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...values, lang }),
    })

    if (response) {
      return await handleResponse(response)
    } else {
      return ''
    }
  }
}
